export const teamData = [
  {
    image: "/images/amy.png",
    name: "Amy Cherry",
    position: "Co-Founder",
    description:
    <p>Leafwellfarm.com investor and partner, Amy founded Shou Sugi Ban House a $50M award-winning wellness property located in the Hamptons, NY. <br /> <br /> </p>,
  },
  {
    image: "/images/yitz.jpg",
    name: "Yitz Klein",
    position: "Co-Founder",
    description: (
      <p className="text-black text-[16px]">
        Yitz developed and acquired $300M of real estate over 15 years - he
        founded <a href="https://www.gideonam.com/" className="text-blue-700">Gideon Asset Management</a>{" "}
        and{" "}
        <a
          href="https://www.thirdhousecapital.com/"
          className="text-semibold text-blue-700"
        >
          Third House Capital.
        </a>{" "}
        He is on a mission to provide impactful living communities to help with
        reconnecting people and joyful living.
      </p>
    ),
  },
  {
    image: "/images/john.jpeg",
    name: "John McKinney",
    position: "Portfolio Management",
    description:
      "John is a portfolio manager and hands on work site manager. Based in NY, John oversees construction and development of each site within the portfolio.",
  },
];

export const cabinData = [
  {
    name: "Meet Your Suite",
    image:
      "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56f1_Untitled_7_c0b8d81a-fc6e-46b1-8b8f-47da34702a5d.webp",
    size: "8.5' x 26'",
    price: "$1,200 per month (day/week available)",
    ticks: [
      { name: "Fully furnished" },
      { name: "Built with top-tier, premium materials" },
      { name: "NOAH+ certified" },
      { name: "Full bathroom" },
      { name: "Micro chef's kitchen" },
      { name: "Est. $1200/month" },
    ],

    features: [
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56d8_turn_key_copy_6.png",
        text: "Queen Bed",
      },
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56dc_Icon_a_5_2.png",
        text: "AC + Heat",
      },
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56d6_turn_key_copy_5.webp",
        text: "Fully Furnished",
      },
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56de_lamp.png",
        text: "Energy Efficient",
      },
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56db_turn_key_copy.png",
        text: "Off-grid ready",
      },
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56da_window.png",
        text: "Huge Windows",
      },
      {
        icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56d7_turn_key.png",
        text: "Move In",
      },
      {
        icon: "/icons/wi-fi.svg",
        text: "Wifi Included",
        sizeSmall: true,
      },
      {
        icon: "/icons/sauna.svg",
        text: "Steam Room",
        sizeSmall: true,
      },
    ],
  },

  // {
  //   name: "Meet The Nomad",
  //   image:
  //     "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e6a416b69a802485da868f_nomad-long-p-1080.webp",
  //   size: "8.5' x 26'",
  //   price: "$99, 000",
  //   ticks: [
  //     { name: "Turn-key, fully furnished" },
  //     { name: "Built with top-tier, premium materials" },
  //     { name: "NOAH+ certified" },
  //     { name: "Full bathroom" },
  //     { name: "Micro chef's kitchen" },
  //     { name: "Est. $475/month with financing" },
  //   ],

  //   features: [
  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56d8_turn_key_copy_6.png",
  //       text: "Queen Bed",
  //     },
  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56dc_Icon_a_5_2.png",
  //       text: "AC + Heat",
  //     },
  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56d6_turn_key_copy_5.webp",
  //       text: "Built to Order",
  //     },

  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56de_lamp.png",
  //       text: "Energy Efficient",
  //     },
  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56db_turn_key_copy.png",
  //       text: "Off-grid ready",
  //     },
  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56da_window.png",
  //       text: "Huge Windows",
  //     },
  //     {
  //       icon: "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f56d7_turn_key.png",
  //       text: "Turn Key",
  //     },
  //   ],
  // },
];

export const upcomingProjects = [
  {
    title: "Hill Country Haven",
    descriptions: [
      "Nestled in the rolling landscapes just outside of Austin, this outpost offers a serene escape into nature with luxurious glamping accommodations.",
      "This retreat combines the rustic charm of Texas Hill Country with modern comforts, inviting guests to unwind among wildflowers and under starlit skies.",
    ],
    images: [
      "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f576a_campsite-0.5.webp",
      "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e93008639eb12afc0bc824_leyre-LnKnYAemWWU-unsplash.jpg",
    ],
  },
  {
    title: "Hill Country Haven",
    descriptions: [
      "Catskill Mountain Escape promises a rejuvenating retreat in the lush landscapes of the Catskills.",
      "This retreat is designed for those who seek both solitude and adventure, providing a peaceful haven to relax, rejuvenate, and explore the natural beauty of Upstate New York.",
    ],
    images: [
      "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e0da8edae1c46e590f5791_Untitled-4.jpg",
      "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e945417a15cb8a97dd1e4f_photo-1602780669668-241ff10e6329%20copy.jpg ",
    ],
  },
  {
    title: "Red Rock Retreat",
    descriptions: [
      "Nestled among the iconic red sandstone formations of Sedona, Red Rock Retreat offers an unparalleled connection to the natural world.",
      "This eco-friendly retreat is designed to blend seamlessly with the surrounding landscape,",
    ],
    images: [
      "https://cdn.prod.website-files.com/65e0da8edae1c46e590f55e2/65e949674ca79cdc7d0c6f4d_jeremy-bishop-VCaJ1-TQoPo-unsplash-p-1600.jpg",
    ],
  },
];

export const amenitiesData = [
  // {
  //   icon: '/icons/tiny-home.svg',
  //   title: 'Minimalist Lifestyle in Modern Tiny Homes',
  //   description: 'Live simply in our fully furnished tiny homes. Enjoy laundry services, but you’ll make your own bed. Ideal for digital nomads and retirees, our wellness-focused, nature-oriented community offers a peaceful retreat from city chaos. Pet-friendly up to a certain size.'
  // },
  // {
  //   icon: '/icons/community.svg',
  //   title: 'Community',
  //   description: 'Join a vibrant and supportive community of like-minded individuals.'
  // },
  {
    icon: "/icons/co-living.webp",
    title: "Co-Live in a Like-Minded Community",
    description: "Live and thrive among a community of like-minded people.",
  },
  // {
  //   icon: '/icons/flexible-living.svg',
  //   title: 'Flexible Living',
  //   description: 'Enjoy the freedom to move between our properties in different states by swapping locations with other tenants.'
  // },
  {
    icon: "/icons/clock.svg",
    title: "45 Minutes or Less from Major Cities",
    description:
      "Enjoy convenient access to major cities, all within two hours or less.",
  },
  {
    icon: "/icons/wi-fi.svg",
    title: "WiFi",
    description:
      "Stay connected with fast, reliable WiFi access throughout the property.",
  },
  {
    icon: "/icons/sauna.svg",
    title: "Steam Room",
    description:
      "Rejuvenate and unwind with our steam room and cold plunge facilities.",
  },
  {
    icon: "/icons/shopping.svg",
    title: "Shopping Nearby",
    description:
      "Access a variety of shopping options conveniently located nearby.",
  },
  {
    icon: "/icons/farm-animals.svg",
    title: "Mini Farm Animals",
    description: "Delight in interacting with our friendly mini farm animals.",
    comingSoon: true,
  },
  {
    icon: "/icons/farming.svg",
    title: "Farming",
    description: "Experience hands-on farming activities and connect deeply with the land.",
    comingSoon: true,
  },
  {
    icon: "/icons/walking.svg",
    title: "Walking Trails",
    description:
      "Stroll through our scenic paths and immerse yourself in nature on our well-maintained walking trails.",
  },
  {
    icon: "/icons/ac-heating.svg",
    title: "A/C & Heating",
    description:
      "Relax in the comfort of modern climate control with air conditioning and heating in all our accommodations.",
  },
  {
    icon: "/icons/board-games.svg",
    title: "Board Games",
    description:
      "Enjoy a selection of classic and contemporary board games for a fun indoor experience.",
  },
  {
    icon: "/icons/lockbox.svg",
    title: "Cell Phone Lockbox",
    description:
      "Disconnect and recharge by securing your devices in our handy cell phone lockboxes.",
  },
  {
    icon: "/icons/bookss.svg",
    title: "Classic Books",
    description:
      "Delve into a collection of classic literature available for your reading pleasure.",
  },
  // {
  //   icon: '/icons/cards.svg',
  //   title: 'Deck of Cards',
  //   description: 'A deck of cards is on hand for a quick game or a round of friendly competition.'
  // },
];

export const faqs = [
  {
    question: 'What is the minimum stay requirement?',
    answer: 'The minimum stay requirement is [X] nights. We do not accommodate single-night stays.',
  },
  {
    question: 'What time is check-in and check-out?',
    answer: 'Check-in is from [Time], and check-out is by [Time]. Early check-ins and late check-outs can be arranged based on availability.',
  },
  {
    question: 'How do I check in to the property?',
    answer: 'We offer a self-check-in process using a smart lock/keypad. Detailed instructions will be provided before your arrival.',
  },
  {
    question: 'What amenities are included?',
    answer: 'The property includes [Wi-Fi, toiletries, a fully equipped kitchen, towels, linens, etc.]. You’ll also have access to [specific amenities like a pool, gym, etc., if applicable].',
  },
  {
    question: 'Is there parking available?',
    answer: 'Yes, there is [on-site/off-site] parking available for [X] vehicle(s). Parking details will be shared prior to your stay.',
  },
  {
    question: 'Are pets allowed?',
    answer: '[Yes/No]. If yes: Pets are allowed with prior approval. There is a pet fee of [$X] per stay.',
  },
  {
    question: 'Can I cancel my reservation?',
    answer: 'Yes, you can cancel your reservation. Our cancellation policy is as follows: [insert details of the cancellation policy, e.g., full refund if canceled 7 days before arrival].',
  },
  {
    question: 'Is there a cleaning fee?',
    answer: 'Yes, a one-time cleaning fee of [$X] is charged per stay. This covers professional cleaning before and after your stay.',
  },
  {
    question: 'What do I do if I need assistance during my stay?',
    answer: 'You can contact us at [phone number/email] anytime during your stay for assistance.',
  },
  {
    question: 'Is there a security deposit?',
    answer: 'Yes, a security deposit of [$X] is required. This is fully refundable within [X] days after checkout, provided no damage is found.',
  },
];
